class HeaderBackground extends HTMLElement {
  constructor() {
    super();

    // Create a shadow root
    this.attachShadow({
      mode: 'open'
    });

    // Create a resize observer to watch for width changes
    this.HeightObserver = new ResizeObserver(() => {
      this.callUpdate();
    });

    // Create a style tag
    this.styleTag = document.createElement('style');

    // Set some styles
    this.styleTag.textContent = `
      :host {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: var(--_border-radius);
      }
    `;

    // Set up a timeouts object
    this.timeouts = {};

    // Append the style tag to the shadow DOM
    this.shadowRoot.appendChild(this.styleTag);
  }
  connectedCallback() {
    // Grab the height data
    this.height = this.offsetHeight;

    // Observe the element
    this.HeightObserver.observe(this);

    // Set some styles
    this.apply();
  }
  callUpdate() {
    clearTimeout(this.timeouts.update);
    this.timeouts.update = setTimeout(() => {
      requestAnimationFrame(() => this.update());
    }, 100);
  }
  update() {
    // // If the height hasn't changed, return
    if (this.height === this.offsetHeight) return;
    // Update the cache
    this.height = this.offsetHeight;
    // Set some styles
    this.apply();
  }
  apply() {
    // Apply this height style to the document
    document.documentElement.style.setProperty('--header-background-height', `${this.height}px`);
    // Set some styles
    this.style.setProperty('--_border-radius', `calc(var(--_border-radius-percentage) * .5 * ${this.height}px)`);
  }
}
;
customElements.define('header-background', HeaderBackground);